export enum GuestPackageType {
  VLEVEL = 'vlevel',
  COLLECTION = 'collection',
  EXTERNAL = 'external',
}

export enum ProductType {
  VIP_SUNBED = 'vip_sunbed',
  VIP_BALINESE = 'vip_balinese',
  POOL_SUNBED = 'pool_sunbed',
  OASIS_SUNBED = 'oasis_sunbed',
  OASIS_BALINESE = 'oasis_balinese',

  PALM_SUNBED = 'palm_sunbed',
  PALM_BALINESE = 'palm_balinese',
  BEACH_SUNBED = 'beach_sunbed',
  BEACH_BALINESE = 'beach_balinese',
}

type ProductPricing = {
  price: number;
  levelPrice: Record<GuestPackageType, number>;
};

export class Prices {
  private static readonly products: Record<ProductType, ProductPricing> = {
    [ProductType.VIP_SUNBED]: {
      price: 78,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 0,
        [GuestPackageType.COLLECTION]: 31,
        [GuestPackageType.EXTERNAL]: 47,
      },
    },

    [ProductType.VIP_BALINESE]: {
      price: 208,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 0,
        [GuestPackageType.COLLECTION]: 83,
        [GuestPackageType.EXTERNAL]: 125,
      },
    },

    [ProductType.POOL_SUNBED]: {
      price: 72,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 0,
        [GuestPackageType.COLLECTION]: 29,
        [GuestPackageType.EXTERNAL]: 43,
      },
    },

    [ProductType.OASIS_SUNBED]: {
      price: 66,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 0,
        [GuestPackageType.COLLECTION]: 26,
        [GuestPackageType.EXTERNAL]: 40,
      },
    },

    [ProductType.OASIS_BALINESE]: {
      price: 176,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 0,
        [GuestPackageType.COLLECTION]: 70,
        [GuestPackageType.EXTERNAL]: 106,
      },
    },

    [ProductType.PALM_SUNBED]: {
      price: 0,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 66,
        [GuestPackageType.COLLECTION]: 66,
        [GuestPackageType.EXTERNAL]: 66,
      },
    },

    [ProductType.PALM_BALINESE]: {
      price: 0,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 176,
        [GuestPackageType.COLLECTION]: 176,
        [GuestPackageType.EXTERNAL]: 176,
      },
    },

    [ProductType.BEACH_SUNBED]: {
      price: 0,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 60,
        [GuestPackageType.COLLECTION]: 60,
        [GuestPackageType.EXTERNAL]: 60,
      },
    },

    [ProductType.BEACH_BALINESE]: {
      price: 0,
      levelPrice: {
        [GuestPackageType.VLEVEL]: 160,
        [GuestPackageType.COLLECTION]: 160,
        [GuestPackageType.EXTERNAL]: 160,
      },
    },
  };

  /**
   * Cijena ležaljke koju treba naplatiti unaprijed.
   */
  static getLoungerPrice(
    product: ProductType,
    guestType: GuestPackageType,
  ): number {
    return this.products[product].levelPrice[guestType];
  }

  /**
   * Ukupan minimum spend proizvoda.
   */
  static getMinSpend(product: ProductType): number {
    return this.products[product].price;
  }

  /**
   * Iznos koji gost može potrošiti na hranu i piće.
   */
  static getPriceForProductType(
    product: ProductType,
    guestType: GuestPackageType,
  ): number {
    const productData = this.products[product];
    const loungerPrice = productData.levelPrice[guestType];

    return productData.price - loungerPrice;
  }

  static getProductDataForType(
    product: ProductType,
  ) {
  return  this.products[product];
  }
}

export const BACKEND_PRODUCT_MAP: Record<string, ProductType> = {
  'vip pool area sunbed': ProductType.VIP_SUNBED,//ok
  'balinese vip pool area': ProductType.VIP_BALINESE,//ok
  'pool area sunbed':ProductType.POOL_SUNBED,//ok
  'oasis sunbed': ProductType.OASIS_SUNBED,//ok
  'balinese oasis': ProductType.OASIS_BALINESE,///provjera kako dolazi sa weba
  'palm sunbed': ProductType.PALM_SUNBED,//ok
  'beach sunbed': ProductType.BEACH_SUNBED,//ok
  'balinese beach': ProductType.BEACH_BALINESE,///provjera kako dolazi sa weba


  // provjeriti s businessom je li ovo stvarno isti proizvod
  'palm balinese': ProductType.PALM_BALINESE,
};

